<h1 mat-dialog-title *ngIf="data.file_name">{{data.file_name}}</h1>
<mat-dialog-content>
    <app-pdf-reader [fileName]="data.file_name" [src]="data.src"></app-pdf-reader>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>{{'label.close' | translate}}</button>
</mat-dialog-actions>